import { defineComponent as _defineComponent } from 'vue'
import { ModelDatasetAtom } from '@/store/model'


export default /*#__PURE__*/_defineComponent({
  __name: 'icon-label',
  props: {
    raw: { type: Object, required: true },
    icon: { type: String, required: true }
  },
  emits: ["updateColor"],
  setup(__props: any, { expose: __expose, emit }) {
  __expose();





const __returned__ = { emit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})